/**
 * Lazy Load Images
 *
 * NOTE: polyfill in /lib/Settings.php
 */

export default () => {
  let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"))

  let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        let lazyImage = entry.target
        lazyImage.src = lazyImage.dataset.src
        if (lazyImage.dataset.srcset) {
          lazyImage.srcset = lazyImage.dataset.srcset
        }
        lazyImage.classList.add('loaded')
        lazyImageObserver.unobserve(lazyImage)
      }
    })
  })

  lazyImages.forEach(function(lazyImage) {
    lazyImageObserver.observe(lazyImage)
  })
}


// WEBPACK FOOTER //
// ./src/js/modules/LazyLoad.js